const REVIEWS_EXCEPTIONS = {
    'reviews_cexcellent': 'reviews_cexcellent',
}

export { REVIEWS_EXCEPTIONS };